import React from "react";
import "../css/Footer.css";
import { useContactSettings } from "./ContactSettingsProvider";

const loanMetrics = [
  "Plazo: 1 a 12 meses",
  "TNA: 136,87% + IVA",
  "CFT: 265,93% + IVA",
  "TEA: 265,93% + IVA",
  "Sin gastos adicionales",
];

const legalLinks = [
  {
    href: "https://microcuotas.com.ar/terminos-y-condiciones-generales-de-contratacion/",
    label: "Terminos y condiciones",
  },
  {
    href: "https://microcuotas.com.ar/terminos-y-condiciones-de-uso-generales/",
    label: "Condiciones de uso",
  },
  {
    href: "https://microcuotas.com.ar/politica-de-privacidad-y-tratamiento-de-datos-personales/",
    label: "Politica de privacidad",
  },
];

const formatPhone = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  const local = digits.startsWith("549") ? digits.slice(3) : digits;
  return local.length === 10
    ? `${local.slice(0, 2)} ${local.slice(2, 6)}-${local.slice(6)}`
    : `+${digits}`;
};

const FooterBar = () => {
  const { whatsappPhone } = useContactSettings();

  return (
  <footer className="app-footer">
    <span className="app-footer__version" aria-label="Version de la aplicacion">
      v4.2.1
    </span>
    <section
      className="app-footer__content"
      aria-label="Informacion sobre prestamos personales"
    >
      <div className="app-footer__top">
        <div className="app-footer__summary">
          <p className="app-footer__title">Informacion importante</p>
          <p className="app-footer__description">
            Prestamos sujetos a evaluacion crediticia y aprobacion comercial.
            Monto, plazo y condiciones finales segun el perfil del solicitante.
          </p>
        </div>

        <ul className="app-footer__metrics" aria-label="Condiciones del prestamo">
          {loanMetrics.map((metric) => (
            <li key={metric}>{metric}</li>
          ))}
        </ul>
      </div>

      <div className="app-footer__bottom">
        <p className="app-footer__company">
          Micro Cuotas es la division de Prestamos para Consumo de TIENDA
          FINANCIERA SRL.
        </p>

        <nav className="app-footer__links" aria-label="Documentacion legal">
          {legalLinks.map(({ href, label }) => (
            <a key={href} href={href} target="_blank" rel="noopener noreferrer">
              {label}
            </a>
          ))}
        </nav>

        <p className="app-footer__contact">
          Consultas: <a href={`tel:+${whatsappPhone}`}>{formatPhone(whatsappPhone)}</a>
        </p>
      </div>
    </section>
  </footer>
  );
};

export default FooterBar;
